var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.person.profileHandle)?_c('a',{attrs:{"href":_vm.baseUrl + 'profile/' + _vm.person.profileHandle}},[_vm._v(_vm._s(_vm.person.userDisplayName))]):_c('span',[_vm._v(_vm._s(_vm.person.userDisplayName))])
}
var staticRenderFns = []

export { render, staticRenderFns }